var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrasebibliotekIkon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.822,
    height: 56.502,
    viewBox: "0 0 59.822 56.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frasebibliotek-ikon",
    transform: "translate(5087.226 -10203.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verified-document-2618577",
    transform: "translate(-5086.226 10204.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8393",
    "data-name": "Path 8393",
    d: "M148.956,85.986H132.9V38.4h30.43V63.845",
    transform: "translate(-118.477 -38.4)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8394",
    "data-name": "Path 8394",
    d: "M40.471,121.488l-12.234,3.389L16.3,81.719,26.864,78.8",
    transform: "translate(-16.3 -73.803)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8395",
    "data-name": "Path 8395",
    d: "M414.839,104.056l5.1-18.394L411.4,83.3",
    transform: "translate(-362.527 -77.746)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    x2: 4.193,
    transform: "translate(19.977 8.411)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    x2: 18.641,
    transform: "translate(19.977 13.495)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    x2: 18.641,
    transform: "translate(19.977 18.579)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    x2: 18.641,
    transform: "translate(19.977 23.663)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    x2: 8.028,
    transform: "translate(19.977 38.915)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    x2: 4.193,
    transform: "translate(19.977 34.079)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_275",
    "data-name": "Ellipse 275",
    cx: 10.071,
    cy: 10.071,
    rx: 10.071,
    ry: 10.071,
    transform: "translate(-5054.903 10232.52)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8913",
    "data-name": "Path 8913",
    d: "M292.7,284.814l2.244,2.244L302.7,279.3",
    transform: "translate(-5341.76 9959.343)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    x2: 8.894,
    y2: 8.894,
    transform: "translate(-5037.712 10249.711)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrasebibliotekIkon);
export default __webpack_public_path__ + "static/media/Frasebibliotek-ikon.b12017c7de6fdb1aea7164ec97c50d15.svg";
export { ForwardRef as ReactComponent };